import {Component, OnInit, OnDestroy, ViewChild, TemplateRef, ChangeDetectionStrategy} from '@angular/core';
import { AssignedAccountsService } from '@irb/irb-clients/assigned-accounts/assigned-accounts-service';
import { AssignedAccountsGridLayoutService } from '@irb/irb-clients/assigned-accounts/assigned-accounts.grid-layout.service';
import {
    IAccount,
    AssignedAccountCount,
    IAccountNameList,
    IAccountSaveResponse,
    IExportRequest,
    IExternalAccounts,
    IExternalAccountsImportResponse,
    IValidateExternalAccountSecuritiesRequest,
    IExternalAccountRequest,
    AccountName,
    IExportFilterDDList,
    IMultipleAccountEditRequest,
    IMultipleAccountEditDto
} from '@irb/irb-clients/irb-clients.model';
import { ISecurity } from '@irb/irb-models/irb-models.model';
import {IEvent, IEventSubscriber, IrbClientsEvents, IrbAppEvents } from '@irb-common/events';
import { Subscription, ReplaySubject, interval } from 'rxjs';
import { AppService } from '@irb/app.service';
import { IrbClientsService } from '@irb/irb-clients/irb-clients.service';
import { HttpHeaders } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { IrbAgGridExportService } from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service';
import { DecimalPipe, DatePipe, CurrencyPipe } from '@angular/common';
import { SelectAllGridParent } from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-select-all-grid-parent';
import { DataTransferService } from '@irb/irb-common/services/data-transfer.service';
import { MenuItemDef } from 'ag-grid-enterprise';
import { BooleanPipe } from '@irb/irb-common/pipes/BooleanPipe';
import { IAlertDialogData, IUserDetails } from "@irb/app.model";
import {FilterChipsComponent} from "@irb-common/components/filter-chips/filter-chips.component";
import {AnalyticsService} from "@irb-common/analytics/analytics.service";
import { IrbAgSearchMultipleColumnFilterComponent } from '@irb/irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-search-multiple-column-filter/irb-ag-search-multiple-column-filter.component';
import { UtilityService } from '@irb/irb-common/services/utility.service';
import { ContextType, CurrentContextService, IContext } from '@charlesschwab/as-ui-core';
import {IrbGridBaseClass} from "@irb-common/components/grid/irb-grid.base";
import { CalltoactionService } from '@irb/irb-common/components/calltoaction/calltoaction.service';
import {PreferencesService} from "@irb-common/services/preferences.service";

@Component({ standalone: false,
    selector: 'dux-assigned-accounts',
    templateUrl: './assigned-accounts.component.html',
    styleUrls: ['./assigned-accounts.component.scss'],
    providers: [DecimalPipe, CurrencyPipe, DatePipe, BooleanPipe],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class AssignedAccountsComponent extends IrbGridBaseClass implements OnInit, OnDestroy, IEventSubscriber, SelectAllGridParent {
    params: any;
    rowData: any[];
    gridOptions: any;
    defaultColDef: any;
    components: any;
    columnDefs: any;
    rowSelection: any;
    rowModelType: any;
    assignedAccounts: any;
    _filterCriteria: string;
    deselectedFromSelectAllRecords: any[] = [];
    currentDisplayed: number;
    footerContent: any;
    assignedAccountCount: AssignedAccountCount;
    hilitedAccountNumbers: any[] = [];
    eventSubscription: Subscription;
    private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
    disableActionBtn = true;
    disableDeleteExternalAccountBtn = true;
    totalRecordsFromServer: number;
    isSelectedAll: boolean;
    uniqueField: string = "accountId";
    modelNameList: IExportFilterDDList;
    portfolioNameList: IAccountNameList;
    headerCheckBoxState: string;
    loadingOverlayComponentParams: any;
    overlayType: any;
    accountSubTypeList: string[] = [];
    accountLocationTypeList: string [] = [];
    masterAccountList: string[] = [];
    modelNameValuesList: string[] = [];
    portfolioNameValuesList: string[] = [];
    isLoading: boolean;
    private showClearFilters: boolean = false;
    _filterChipModel: any = {};
    @ViewChild("filterChipsComp")
    filterChipsComp: FilterChipsComponent;
    filterDisplayNamesData: { key: string, mapData: { displayName: string, customData:any, format?: any } }[];
    isUiTest = false;
    checkImportExternalAccountsSub: Subscription;
    totalAccountCount: number;
    hasServerSideDatasource = false;
    progressTimer: any;
    isDistHoldCashEnabled: boolean;
    componentName: string = "assignedaccounts-v002";
    firstTimeFlag = true;
    selectedRowsMap: Map<string, any> = new Map<string, any>();
    redirectURL: string;
    ENABLE_FLYOUT: boolean = true;
    window: any;
    baseGridApi: any;
    userDetails: IUserDetails;
    @ViewChild('accountNumberOverlay') accountNumberOverlay: TemplateRef<any>;
    row: any;
    sacMenuItems = [
        { sanc: 'A_BAL', label: 'Balances' },
        { sanc: 'A_POS', label: 'Positions' },
        { sanc: 'A_TRAN', label: 'Transactions' },
        { sanc: 'A_COST', label: 'Cost Basis' },
        { sanc: 'A_RMD', label: 'RMD' }
    ];
    columnLimits: any;
    gridFilterPreference = 'assigned-accounts-filter-pref';
    gridColumnPreference = 'assigned-accounts-column-pref';

    constructor(
        private readonly aas: AssignedAccountsService,
        private cs: IrbClientsService,
        public as: AppService,
        private router: Router,
        public ges: IrbAgGridExportService,
        private decimalPipe: DecimalPipe,
        public dataTransferService: DataTransferService,
        private gls: AssignedAccountsGridLayoutService,
        public ats: AnalyticsService,
        private util: UtilityService,
        private cxs: CurrentContextService,
        private ctas: CalltoactionService,
        public pref: PreferencesService
    ) {
        super();
        this.userDetails = this.as.getItem("IRB_APP_CONFIG") as IUserDetails;
        this.ENABLE_FLYOUT = this.as.getItem('IRB_APP_CONFIG')?.featureFlags.ENABLE_FLYOUT;
        this.isDistHoldCashEnabled = this.as.getItem("IRB_APP_CONFIG")?.isDistHoldCashEnabled || false;
        this.columnLimits = this.gls.getColumnLimits();

        this.ats.trackAccountsEvent();
        let rowIdIteration = -1;
        this.gridOptions = {
            rowModelType: 'serverSide',
            columnDefs: this.gls.getColumnDefs(this),
            rowSelection: 'multiple',
            rowClassRules: {
                'modifiedRow': (function (params: any) {
                    return (params.data) ? this.hilitedAccountNumbers.indexOf(params.data.accountNumber) !== -1 : false;
                }).bind(this)
            },
            context: { componentParent: this, closeToolPanelOnInitialLoad: true },
            getRowId: (params: any) => {
                rowIdIteration++;
                const rowId = 'RowId' + rowIdIteration;
                return params.data.accountNumber + rowId;
            },
            onSortChanged: () => {
                if(this.hasServerSideDatasource) {
                    this.setDatasource();
                } else {
                    this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
                }
            }
        };
        this.defaultColDef = { filter: false, menuTabs: [] };
        this.rowSelection = 'multiple';
        this.rowModelType = 'serverSide';
        this.eventSubscription = this.as.getEvents().pipe(takeUntil(this.destroyed$)).subscribe((s) => { this.processEvent(s); });
        this.setFilterChipsDisplayNames();
        this.redirectURL = this.as.getItem('IRB_APP_CONFIG')?.veoRedirectUrl;
        this.window = window;
        this.presetFiltersdataFromSavedFilters();
        this.getGridColumnPreference();
    }

    onGridReady(params: any) {
        this.params = params;
        this.baseGridApi = params.api;
        if (this.firstTimeFlag)
            this.addHiddenColumnFiltersOnInitialLoad();

        if(this.hasServerSideDatasource) {
            this.setDatasource();
        } else {
            //this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
            this.params.api.showLoadingOverlay();
            this.triggerInitialLoadData(100);
        }

        this.getFilterAndCountData();
    }

    getFilterAndCountData() {
        this.getAssignedAccountCount();
        this.getaccountsubTypeList();
        this.getPortfolioList();
        this.getAccountLocationType();
        this.getMasterAccountNumber();
        this.getModelName();
      //  this.getCustodianOnPermission();
    }

    setDatasource() {
        this.hasServerSideDatasource = true;
        return {
            getRows: (params: any) => {
                this.overlayType = 'loading';

                if (this.params) {
                    this.params.api.showLoadingOverlay();
                }

                this._filterChipModel = params.request.filterModel;
                const modelFilterIds = this.getModelFilterIds(params, this.modelNameList, 'modelName');
                const portfolioFilterIds = this.getPortfolioFilterIds(params, this.portfolioNameList, 'portfolio');
                this.saveGridFiltersToLocal(this._filterChipModel);
                this.aas.getAssignedAccounts(params, modelFilterIds, portfolioFilterIds).subscribe(data => {
                    this._filterCriteria = this.aas._filterCriteria;
                    this.assignedAccounts = <IAccount[]>data.body;

                    const ex: any = (this.assignedAccounts as any).responseUtilityMap;
                    if (ex) {
                        if (ex['Controller Exception']) {
                            const err: any = {};
                            err.message = 'assigned Accounts inv call failed. ';
                            err.message += ex['Controller Exception'];
                            if (!this.isUiTest) {
                                this.params.api.hideOverlay();
                                throw new Error(err.message);
                            }
                        }
                    }
                    
                    this.getCurrentCount(data.headers);
                    
                    if (this.currentDisplayed === 0) {
                        this.showClearFilters = this._filterCriteria  !== '';
                        this.params.api.showNoRowsOverlay();
                    } else {
                        this.params.api.hideOverlay();
                        this.assignedAccounts.forEach((r: IAccount) => {
                            //populate symbols for cash targets
                            if (r.cashMinimum) {
                                r.cashSymbol = r.cashMinimum.includes('$') ? "$" : "%";
                            } else if (r.cashMaximum) {
                                r.cashSymbol = r.cashMaximum.includes('$') ? "$" : "%";
                            } else if (r.cashTarget) {
                                r.cashSymbol = r.cashTarget.includes('$') ? "$" : "%";
                            } else {
                                r.cashSymbol = "";
                            }

                            //populate symbols for set aside amount
                            if (r.curAmount) {
                                r.setAsideSymbol = r.curAmount.includes('$') ? "$" : "%";
                            } else {
                                r.setAsideSymbol = "";
                            }

                            //Format boolean as Y/N
                            r.isDividendReinvestFormatted = (r.isDividendReinvest) ? "Y" : "N";
                            r.isCapGainsReinvestFormatted = (r.isCapGainsReinvest) ? "Y" : "N";
                            r.isDoNotTradeFormatted = (r.isDoNotTrade) ? "Y" : "N";
                           // r.custodian =(r.custodian) ?  r.custodian: "TD AMERITRADE";
                        });
                    }

                    params.success({ rowData: this.assignedAccounts });
                }, () => {
                    params.success({ rowData: [] });
                    this.showClearFilters = this._filterCriteria  !== '';
                    this.params.api.hideOverlay();
                    this.params.api.showNoRowsOverlay();
                });
            }
        };
    }

    private getCurrentCount(headers: HttpHeaders) {
        const contentRange = headers.get('Filter-Count');
        const lengthOfContentRange = contentRange ? contentRange.trim().length : 0;
        const indexOfSlash = contentRange ? contentRange.toString().indexOf('/') : 0;
        this.currentDisplayed = contentRange ? parseInt(contentRange.toString().substring(indexOfSlash + 1, lengthOfContentRange)) : 0;
        this.footerContent = this.currentDisplayed + ' of ' + this.assignedAccountCount?.responseData + ' accounts displayed';
        this.totalRecordsFromServer = this.currentDisplayed;
    }

    roundDollarString(s: any) {
        if (s && (s.includes("$") || s.includes("$-"))) {
            const isNegativeValue = s.includes("$-") ? true : false;
            const onlyValue = isNegativeValue ? s.replace("$-", "") : s.replace("$", "");
            const roundedValue = this.decimalPipe.transform(Math.round(parseFloat(onlyValue)));
            return isNegativeValue ? "($" + roundedValue + ")" : "$" + roundedValue;
        } else if (s && (s.includes("%") || s.includes("-"))) {
            const isNegativeValue = s.includes("-") ? true : false;
            const onlyValue = isNegativeValue ? s.replace(/[-%]/gi, "") : s.replace("%", "");
            return isNegativeValue ? "(" + onlyValue + "%)" : + onlyValue + "%";
        } else {
            return s;
        }
    }

    parseValueString(s: string) {
        if (s && s.includes("$")) {
            return parseFloat(s.replace("$", ""));
        } else if (s && s.includes("%")) {
            return parseFloat(s.replace("%", ""));
        } else {
            return s;
        }
    }

    clearAllFilters() {
        this._filterCriteria = '';
        this.aas.clearCriteria();
        if (this.gridOptions) {
            this.params.api.setFilterModel(null);
            this.params.api.refreshToolPanel();
        }

        this.isSelectedAll= false;
        this.selectedRowsMap = new Map<string, any>();
        this.deselectedFromSelectAllRecords = [];
        this.headerCheckBoxState = 'unchecked';
        this.enableDisableBtns();  
    }

    getSelectedPortfolioIdIds() {
        const selectedPort: Array<number> = [];
        if (this.gridOptions) {
            this.selectedRowsMap.forEach((item: any) => {
                if (selectedPort.indexOf(item.portfolioId) < 0) { // avoid duplicate ids
                    selectedPort.push(item.portfolioId);
                }
            });
        }
        return selectedPort;
    }

    getAssignedAccountCount() {
        this.aas.getAssignedAccountCount().subscribe((assignedAccountCount: any) => {
            this.assignedAccountCount = assignedAccountCount;
            if (this.currentDisplayed && this.assignedAccountCount.responseData) {
                this.footerContent = this.currentDisplayed + ' of ' + this.assignedAccountCount.responseData + ' accounts displayed';
            }
        });
    }


    setFilterValues(fieldName: string, setValuesList: string[]) {
        if (this.gridOptions) {
            this.params.api.getColumnFilterInstance(fieldName).then((f:any) => {
                f.setModel({
                    type: 'set',
                    values: setValuesList
                });
                f.setFilterValues(setValuesList);
            });
        }
    }

    getAssignedAccountNumber(str: string, d: IrbAgSearchMultipleColumnFilterComponent) {
        if(str.length > 0) {
            this.aas.paramsForAcctNum = str;
            this.aas.getAssignedAccountNumber().subscribe((res: Array<AccountName>) => {
                d.set(res);
            });  
        }
    }

    getAssignedAccountName(str: string, d: IrbAgSearchMultipleColumnFilterComponent) {
        if(str.length > 0) {
            this.aas.paramsForAcctName = str;
            this.aas.getAssignedAccountName().subscribe((res: Array<AccountName>) => {
                const a: AccountName[] = [];
                
                //group items by account name
                res.forEach((item: AccountName) => {
                    let target = a.find((x: AccountName) => x.name === item.name);

                    if(target) {
                        let b = target.value.toString().split(",");
                        b.push(item.value);
                        target.value = b.join(",");
                    } else {
                        a.push(item);
                }
                });

                d.set(a.filter((x: AccountName) => x.name.toLowerCase().includes(str.toLowerCase())));
            });
        }
    }

    getAccountSetFilterSelectedGetIds(params: any, list: IAccountNameList, fieldName: string) {
        const selectedIds = [];
        if (params.request.filterModel && params.request.filterModel[fieldName]) {
            const selectedValues = params.request.filterModel[fieldName].values;
            if (selectedValues && selectedValues.length) {
                for (const record of selectedValues) {
                    const result = list.items.filter(s1 => s1.name === record);
                    for(const item of result) {
                        selectedIds.push(item.value);
                    }
                }
            }
        }
        return selectedIds;
    }

    getaccountsubTypeList() {
        this.aas.getComboDropDownValues('accountsubType').subscribe((res: string[]) => {
            res.sort(this.compare);
            this.accountSubTypeList = res;
            // this.setFilterValues('accountsubType', res);
        });
    }

    getPortfolioList() {
        this.aas.getPortfolioNameDropDownValues().subscribe((res: any) => {
            this.portfolioNameValuesList = [];
            for (const r of res.items) {
                if (r.name) {
                    this.portfolioNameValuesList.push(r.name);
                }
            }

            this.portfolioNameValuesList = this.util.sortArrayList(this.portfolioNameValuesList);
            this.portfolioNameValuesList.unshift('(none)');

            this.portfolioNameList = res;
            this.portfolioNameList.items.push({value: '(none)', name: '(none)'});
        });
    }

    getAccountLocationType() {
        this.aas.getComboDropDownValues('accountLocationType').subscribe((res: string[]) => {
            res.sort(this.compare);
            this.accountLocationTypeList = res;
            // this.setFilterValues('accountLocationType', res);
        });
    }
    getMasterAccountNumber() {
        this.aas.getComboDropDownValues('masterAccount').subscribe((res: string[]) => {
            res.sort(this.compare);
            this.masterAccountList = res;
            // this.setFilterValues('masterAccount', res);
        });
    }

    getModelName() {
        this.aas.getModelNameDropDownValues().subscribe((res: IExportFilterDDList) => {
            this.modelNameValuesList = [];
            for (const r of res.items) {
                if (r.name) {
                    this.modelNameValuesList.push(r.name);
                }
            }

            this.modelNameValuesList = this.util.sortArrayList(this.modelNameValuesList);
            this.modelNameValuesList.unshift('(none)');

            this.modelNameList = res;
            this.modelNameList.items.push({id: '(none)', name: '(none)'});
        });
    }

    getModelFilterIds(params: any, list: IExportFilterDDList, fieldName: string) {
        const s: any = [];

        if (params.request.filterModel && params.request.filterModel[fieldName]) {
            const selectedValues = params.request.filterModel[fieldName].values;
            let dataArray = [];
            if (list && list.items) {
                for (const r of selectedValues) {
                    const result = list.items.filter(s1 => s1.name === r);
                    dataArray.push(...result);
                    result.forEach((r: any) => {
                        s.push(r.id);
                    });
                }
            }
            params.request.filterModel[fieldName].list = dataArray;
        }

        return s;
    }

    getPortfolioFilterIds(params: any, list: IAccountNameList, fieldName: string) {
        const s: any = [];

        if (params.request.filterModel && params.request.filterModel[fieldName]) {
            const selectedValues = params.request.filterModel[fieldName].values;
            let dataArray = [];
            if (list && list.items) {
                for (const r of selectedValues) {
                    const result = list.items.filter(s1 => s1.name === r);
                    dataArray.push(...result);
                    result.forEach((r: any) => {
                        s.push(r.value);
                    });
                }
            }
            params.request.filterModel[fieldName].list = dataArray;
        }

        return s;
    }

    createRebalance() {
        this.ats.trackClickEvent("lc_rebal");
        const _filterCriteria = this.isSelectedAll ? (this._filterCriteria ? ('?' + this._filterCriteria) : '') : '';
        const _serviceURL = '/irebalone/accounts/get-ids-by-filter-criteria/' + _filterCriteria;
        let _portfolioIdsList;
        let _message = '';
        if(this.isSelectedAll) {
            const deselectedIds: any = [];
            this.deselectedFromSelectAllRecords.forEach((node: any) => {
                deselectedIds.push(node.accountNumber);
            });
            this.aas.getAllAccountDetails(this.isSelectedAll, deselectedIds).subscribe((res: any) => {
                let accounts = res;
                const selectedPort: Array<number> = [];
                const deselectedFromSelectAllRecords: any [] = [];
                // if(deselectedIds.length > 0) {
                //     for (let accountData of res) {
                //         if (deselectedIds.indexOf(accountData.accountNumber) < 0) {
                //             accounts.push(accountData);
                //         }
                //     }
                // } else {
                //     accounts = res;
                // }
                // accounts = res;
                if (accounts && accounts.length > 0) {
                    accounts.forEach((item: any) => {
                        if (selectedPort.indexOf(item.portfolioId) < 0) {
                            // avoid duplicate ids
                            selectedPort.push(item.portfolioId);
                        }
                    });
                }
                _portfolioIdsList = selectedPort;
                _message =  ('The portfolio(s) for ' + accounts.length + ' account(s) will be rebalanced.');
                if (_portfolioIdsList && _portfolioIdsList.length > 0) {
                    const crConfig = {
                        'serviceURL': _serviceURL,
                        'portfolioIdsList': _portfolioIdsList,
                        'deselectedFromSelectAllRecords': deselectedFromSelectAllRecords,
                        'message': _message
                    };
                    this.as.fireEvent('createRebalance', crConfig);
                }
            });
        } else {
            _portfolioIdsList = this.getSelectedPortfolioIdIds();
            if(_portfolioIdsList.length >= 1){
                _message = _portfolioIdsList.length + ' portfolio(s) will be rebalanced.';
                if (_portfolioIdsList && _portfolioIdsList.length > 0) {
                    const crConfig = {
                        'serviceURL': _serviceURL,
                        'portfolioIdsList': _portfolioIdsList,
                        'deselectedFromSelectAllRecords': this.deselectedFromSelectAllRecords,
                        'message': _message
                    };
                    this.as.fireEvent('createRebalance', crConfig);
                }
            }
           
        }

    }

    enableDisableBtns() {
        this.disableActionBtn = (this.isSelectedAll || this.selectedRowsMap?.size) ? false : true;
        //todo: refactor getSelectedExternalAccounts and its .hasExternalAccount method
        if (!this.disableActionBtn) {
            this.disableDeleteExternalAccountBtn = this.getSelectedExternalAccounts().hasExternalAccount ? false : true;
        }
    }

    ngOnInit(): void {
        this.loadingOverlayComponentParams = { parentObject: this };
    }

    ngOnDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
        this.eventSubscription.unsubscribe();
    }

    processEvent(event: IEvent): void {
        switch (event.type) {
            case IrbAppEvents.GRID_REFRESH:
                this.refreshGrid();
                break;
            case IrbAppEvents.GRID_FILTER_RESET:
                this.clearAllFilters();
                break;
            case IrbClientsEvents.IMPORT_CASH_SETTINGS_COMPLETE:
                this.completeImportCashSettings(event.data);
                break;
            case IrbClientsEvents.IMPORT_EXTERNAL_ACCOUNTS_VALIDATE:
                this.validateImportExternalAccounts(event.data);
                break;
            case IrbClientsEvents.IMPORT_EXTERNAL_ACCOUNTS_COMPLETE:
                this.completeImportExternalAccounts(event.data);
                break;
            case IrbAppEvents.FIRE_TRACKING_EVENT:
                this.ats.trackAccountsEvent();
                break;
        }
    }

    refreshGrid() {
        if (this.params) {
            //this.params.api.deselectAll();
            //this.headerCheckBoxState = "unchecked";
            this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
        }
        this.getFilterAndCountData();
    }

    showImportCashSettingsDialog() {
        this.as.fireEvent(IrbClientsEvents.SHOW_IMPORT_CASH_SETTINGS);
    }

    completeImportCashSettings(data: any) {
        this.as.fireEvent(IrbAppEvents.SHOW_WAIT);

        this.cs.updateImportAccountCashSettingsAsync(data.validRecords).subscribe((response: any) => {
            //this.updateImportCashSettingsFinish(response);
            if (this.progressTimer) clearTimeout(this.progressTimer);
            if (response.responseStatus === "SUCCESS" && response.responseUtilityMap)
                this.actionStatusCheckIntervalStart(response.responseUtilityMap.statusId);
        }, () => {
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        });
    }

    actionStatusCheckIntervalStart(statusId: any) {
        this.cs.importStatusCheck(statusId).subscribe((statusResponse: any) => {
            if (statusResponse.responseStatus === "SUCCESS") {
                let reqStatus = 'FAILED';
                // if (statusResponse.responseUtilityMap && statusResponse.responseUtilityMap.reqStatus) {
                //     reqStatus = statusResponse.responseUtilityMap.reqStatus.trim().toUpperCase();
                // }
                reqStatus = statusResponse.responseData.reqStatus.trim().toUpperCase();

                if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
                    let timeout = this.isUiTest ? 0 : 1500;
                    this.progressTimer = setTimeout(() => {
                        this.actionStatusCheckIntervalStart(statusId);
                    }, timeout);
                }

                if (reqStatus === 'COMPLETED') {
                    this.updateImportCashSettingsFinish(statusResponse);
                }

                if (reqStatus === 'FAILED') {
                    this.actionStatusCheckFailed();
                }
            } else if (statusResponse.responseStatus === "BUSINESS_ERR_MSG" || statusResponse.responseStatus === "EXCEPTION") {
                this.actionStatusCheckFailed();
            } else if (statusResponse.responseStatus === "STALEDATAEXCEPTION") {
                this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                if (this.progressTimer) clearTimeout(this.progressTimer);
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                    severity: 'error',
                    summary: 'Import Cash Settings',
                    detail: "You are attempting to import items which were modified by another user. Please try your import again."
                });
            }
        }, () => {
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            if (this.progressTimer) clearTimeout(this.progressTimer);
        });
    }

    actionStatusCheckFailed() {
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        if (this.progressTimer) clearTimeout(this.progressTimer);
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: 'Import Cash Settings',
            detail: "You are attempting to import items which were modified by another user. Please try your import again."
        });
    }

    updateImportCashSettingsFinish(d: any) {
        if (this.progressTimer) clearTimeout(this.progressTimer);
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);

        if (d.responseStatus === "SUCCESS") {
            this.hilitedAccountNumbers = [];
            let successRecCount;

            if (Array.isArray(d.responseData)) {
                d.responseData.forEach((r: any) => {
                    this.hilitedAccountNumbers.push(r.accountNumber);
                });
                successRecCount = d.responseData.length;
            } else
                successRecCount = d.responseData.successRecCount;
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: 'success',
                summary: 'Import Cash Settings',
                detail: "The cash settings for " + successRecCount + " account(s) were successfully imported (highlighted below)."
            });

            this.refreshGrid();
        }
    }

    validateExternalAccountSecuritiesAsync(req: IValidateExternalAccountSecuritiesRequest) {
        this.cs.validateExternalAccountSecuritiesAsync(req).subscribe((data: any) => {
            this.progressTimer && clearTimeout(this.progressTimer);
            if(data.responseStatus === "SUCCESS") {
                this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
                this.validateExtAcctSecCheckIntervalStart(data.responseUtilityMap.statusId);
            } else {
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                    severity: 'error',
                    summary: 'Import Orders',
                    detail: " An error occurred processing your request."
                });
            }
        });
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    }

    updateProgressBarStatus(statusId: any) {
        let timeout = this.isUiTest ? 0 : 3000;
        if (this.isUiTest) timeout = 0;
        this.progressTimer = setTimeout(() => {
            this.validateExtAcctSecCheckIntervalStart(statusId);
        }, timeout);
    }

    validateExtAcctSecCheckIntervalStart(statusId: any) {
        this.cs.validateExternalAccountSecuritiesAsyncStatus(statusId).subscribe((statusResponse: any) => {
            if (statusResponse.responseStatus === "SUCCESS") {
                const response = statusResponse?.responseData;

                const reqStatus = statusResponse.responseUtilityMap.reqStatus.trim().toUpperCase();

                if (reqStatus === 'FAILED') {
                    this.actionStatusCheckFailed();
                }

                if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
                    this.updateProgressBarStatus(statusResponse.responseUtilityMap.statusId);
                }
                if (reqStatus === 'COMPLETED') {
                    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                    if(statusResponse.responseStatus === "SUCCESS") {
                        /*
                            for unRecognized securities:
                            ensure externalSharePrice is set, default to 1
                            ensure securityType is EXTERNAL
                        */
                        response.unRecognizedList.forEach((r: ISecurity) => {
                            r.externalSharePrice = "1";
                            r.securityType = "EXTERNAL";
                        });

                        let c = response.nonInventoriedList.length;
                        c += response.unRecognizedList.length;

                        if(c > 0) {
                            //allow the user to decide what to do with associated securities
                            this.as.fireEvent(IrbClientsEvents.SHOW_IMPORT_EXTERNAL_ACCOUNTS_SECURITIES, statusResponse);
                        } else {
                            //there are no associated securities
                            this.as.fireEvent(IrbClientsEvents.SHOW_IMPORT_EXTERNAL_ACCOUNTS_READY, statusResponse);
                        }
                    }

                }
            } else if(statusResponse.responseStatus === "BUSINESS_ERR_MSG" || statusResponse.responseStatus ===  "EXCEPTION") {
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                    severity: 'error',
                    summary: 'Import External Accounts',
                    detail: "An error occurred while processing your request."
                });
                this.progressTimer && clearTimeout(this.progressTimer);
                this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            } else if(statusResponse.responseStatus === "STALEDATAEXCEPTION") {
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                    severity: 'error',
                    summary: 'Import External Accounts',
                    detail: "You are attempting to import items which were modified by another user. Please try your import again."
                });
                this.progressTimer && clearTimeout(this.progressTimer);
                this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            }
        }, () => {
            this.progressTimer && clearTimeout(this.progressTimer);
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        });
    }

    showImportExternalDialog() {
        this.as.fireEvent(IrbClientsEvents.SHOW_IMPORT_EXTERNAL_ACCOUNTS);
    }

    validateImportExternalAccounts(data: IExternalAccounts) {
        const req = {
            validRecordsList: data.validRecordsList || data.validRecords || [],
            overrideExtAccts: data.overrideExtAccts,
            newExtAccts: data.newExtAccts,
            totalCount: data.totalCount,
            restoreAcctList: data.restoreAcctList || []
        } as IValidateExternalAccountSecuritiesRequest;

        // submit validated external accounts
        this.as.fireEvent(IrbAppEvents.SHOW_WAIT);

        this.validateExternalAccountSecuritiesAsync(req);
    }

    completeImportExternalAccounts(data: IExternalAccounts) {
        this.hilitedAccountNumbers = data.validRecordsList?.map(x => x.object[0]);
        this.totalAccountCount = data.totalCount;

        this.cs.insertImportedExternalAccounts(data).subscribe((response: IExternalAccountsImportResponse) => {
            if(response.responseStatus === "EXCEPTION" || typeof response.responseUtilityMap.importStatusId === "undefined") {
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                    severity: 'error',
                    summary: 'Import External Accounts',
                    detail: "An error occurred processing your request."
                });
            } else {
                this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
                this.checkImportExternalAccountsAsyncStatus(response.responseUtilityMap.importStatusId);
            }
        });
    }

    checkImportExternalAccountsAsyncStatus(importStatusId: string) {
        const intervalValue = this.isUiTest ? 0 : 3000;
        this.checkImportExternalAccountsSub = interval(intervalValue).subscribe(() => {
            this.cs.importExternalAccountsStatus(importStatusId).subscribe((response: IExternalAccountsImportResponse) => {
                if(response.responseUtilityMap.actionStatus.reqStatus.toUpperCase() === "COMPLETED") {
                    this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                        severity: 'success',
                        summary: 'Import External Accounts',
                                detail: this.totalAccountCount + " external account(s) were successfully imported (highlighted below)."
                    });

                    this.checkImportExternalAccountsSub.unsubscribe();
                    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                    this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
                } else if(response.responseStatus !== "SUCCESS" || response.responseUtilityMap.actionStatus.reqStatus.toUpperCase() === "FAILED") {
                    this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                        severity: 'error',
                        summary: 'Import External Accounts',
                        detail: "An error occurred processing your request."
                    });
                    this.checkImportExternalAccountsSub.unsubscribe();
                    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                } else if(response.responseUtilityMap.actionStatus.reqStatus.toUpperCase() === "IN_PROGRESS") {
                }
            });
        });
    }

    showCreateExternalDialog() {
        this.as.fireEvent(IrbClientsEvents.SHOW_CREATE_EXTERNAL_ACCOUNTS);
    }

    onRowChange(rowIndex: number, dataToUpdate: IAccount,  field: string) {
        this.overlayType = 'loading';
        this.params.api.showLoadingOverlay();
        this.aas.saveInlineAccount(dataToUpdate).subscribe((data: any) => {
            const response = data as IAccountSaveResponse;

            if (response.responseStatus === "SUCCESS") {
                if (response.responseUtilityMap != null) {
                    // console.log('After success in if  version :' + response.responseData.versionID);
                } else {
                    this.aas.getInlineAccount(dataToUpdate.accountId).subscribe((dataT: IAccount) => {
                        const rowNode = this.params.api.getDisplayedRowAtIndex(rowIndex);
                        rowNode.setData(dataT);
                        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, { severity: 'success', summary: 'Success', detail: 'Your change has been saved' });
                        rowNode.data.edited = true;
                        rowNode.data['edited'] = true;
                        const n = this.params.api.getDisplayedRowAtIndex(rowIndex);
                        this.params.api.redrawRows({ rowNodes: [n] });
                    });

                    this.params.api.hideOverlay();
                }
            } else if (response.responseStatus === "STALEDATAEXCEPTION") {
                this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
                    dTitle: 'Refresh Required',
                    dProceedBtnLabel: 'Refresh',
                    msg: "You are attempting to edit an account that was just modified by someone else. To see the updated account, you need to refresh the page.",
                    onProceed: () => {this.as.fireEvent(IrbAppEvents.GRID_REFRESH);},
                    onCancel: () => {

                        this.params.api.hideOverlay();
                        const rowNode = this.params.api.getDisplayedRowAtIndex(rowIndex);
                        rowNode.data[field] = !rowNode.data[field];
                        this.params.api.redrawRows({ rowNodes: [rowNode] });

                    }

                } as IAlertDialogData);

            } else {
                // console.log("response.responseStatus : " + response.responseStatus);
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, { severity: 'error', summary: 'Update failed.', detail: 'Update failed"' });
                // this.as.fireEvent(IrbEditorsEvents.SAVE_ERROR);
                this.params.api.hideOverlay();
            }
        }, () => {
            //this.as.fireEvent(IrbEditorsEvents.SAVE_ERROR);
            this.params.api.hideOverlay();
        });
    }

    exportAccountCashSettings(selectedId?: number) {
        const headerName = this.params.api.getAllDisplayedColumns()[0]['colDef']['headerName'];

        if (headerName === 'Select All') {
            this.params.api.getAllDisplayedColumns().splice(0, 1);
        }

        if ((this.isSelectedAll || this.selectedRowsMap.size === 0) && !selectedId) {
            const deselectedIds: any = [];

            this.deselectedFromSelectAllRecords.forEach((node: any) => {
                deselectedIds.push(node.accountNumber);
            });

            this.aas.exportAllAccountCashSettings(true, deselectedIds).subscribe((_res: any) => {
                this.ges.showSuccessMessage();
            }, ()=>{});
        } else {
            const f: any[] = (selectedId) ? [selectedId] : [];

            if(!selectedId) {
                this.selectedRowsMap.forEach((node: any) => {
                    f.push(node.accountNumber);
                });
            }

            this.aas.exportSpecificAccountCashSettings(f).subscribe((_res: any) => {
                this.ges.showSuccessMessage();
            },()=>{});
        }
    }

    exportAccountDetails(selectedId?: number) {
        const r = {} as IMultipleAccountEditRequest;
        r.isSelectAll = (this.isSelectedAll || this.selectedRowsMap.size === 0) && !selectedId;
        r.deselectedIds = [];
        r.selectedIds = (selectedId) ? [selectedId] : [];

        if(r.isSelectAll) {
            this.deselectedFromSelectAllRecords.forEach((node: any) => {
                r.deselectedIds.push(node.accountNumber);
            });
        } else {
            this.selectedRowsMap.forEach((node: any) => {
                r.selectedIds.push(node.accountNumber);
            });
        }
    
        this.aas.exportAccountDetails(r).subscribe((_res: any) => {
            this.ges.showSuccessMessage();
        }, () => {});
    }

    getCashMinimum = (params: any) => {
        if (!params.data?.isSMA) {
            if ((params.data?.isGlobal && params.data?.useModelCash && params.data?.globalCashMinimum != null) || params.data?.useModelCashAtAccount) {
                return 'model';
            } else if (params.data?.isGlobal) {
                return this.roundDollarString(params.data?.globalCashMinimum);
            } else {
                return this.roundDollarString(params.data?.cashMinimum);
            }
        } else {
            return 'n/a';
        }
    }
    getCashMinimumExport = (params: any) => {
        if (!params.data?.isSMA) {
            if (((params.data?.isGlobal === true || params.data?.isGlobal ==='Y') && params.data?.useModelCash && params.data?.globalCashMinimum != null) || params.data?.useModelCashAtAccount) {
                return 'model';
            } else if ((params.data?.isGlobal === true ||params.data?.isGlobal ==='Y')) {
                return this.roundDollarString(params.data?.globalCashMinimum);
            } else {
                return this.roundDollarString(params.data?.cashMinimum);
            }
        } else {
            return 'n/a';
        }
    }
    getCashTarget = (params: any) => {
        if (!params.data?.isSMA) {
            if ((params.data?.isGlobal && params.data?.useModelCash && params.data?.globalCashTarget != null) || params.data?.useModelCashAtAccount) {
                return 'model';
            } else if (params.data?.isGlobal) {
                return this.roundDollarString(params.data.globalCashTarget);
            } else {
                return this.roundDollarString(params.data?.cashTarget);
            }
        } else {
            return 'n/a';
        }
    }
    getCashTargetExport = (params: any) => {
        if (!params.data?.isSMA) {
            if (((params.data?.isGlobal === true || params.data?.isGlobal ==='Y') && params.data?.useModelCash && params.data?.globalCashMinimum != null) || params.data?.useModelCashAtAccount) {
                return 'model';
            } else if ((params.data?.isGlobal === true ||params.data?.isGlobal ==='Y')) {
                return this.roundDollarString(params.data?.globalCashTarget);
            } else {
                return this.roundDollarString(params.data?.cashTarget);
            }
        } else {
            return 'n/a';
        }
    }
    getCashMaximum = (params: any) => {
        if (!params.data?.isSMA) {
            if ((params.data?.isGlobal && params.data?.useModelCash && params.data?.globalCashMaximum != null) || params.data?.useModelCashAtAccount) {
                return 'model';
            } else if (params.data?.isGlobal) {
                return this.roundDollarString(params.data.globalCashMaximum);
            } else {
                return this.roundDollarString(params.data?.cashMaximum);
            }
        } else {
            return 'n/a';
        }
    }

    getCashMaximumExport = (params: any) => {
        if (!params.data?.isSMA) {
            if (((params.data?.isGlobal === true || params.data?.isGlobal ==='Y' ) && params.data?.useModelCash && params.data?.globalCashMaximum != null) || params.data?.useModelCashAtAccount) {
                return 'model';
            } else if ((params.data?.isGlobal === true ||params.data?.isGlobal ==='Y')) {
                return this.roundDollarString(params.data.globalCashMaximum);
            } else {
                return this.roundDollarString(params.data?.cashMaximum);
            }
        } else {
            return 'n/a';
        }
    }

    getContextMenuItems(): Array<MenuItemDef> {
        return [
            {
                name: "Export CSV",
                action: () => this.exportAccountDetails()
            }
        ];
    }

    exportExternalAccountHoldings(selectedId?: number) {
        const r = {} as IExportRequest;
        r.selectedIds = (selectedId) ? [selectedId] : [];
        r.deselectedIds = [];

        if ((this.isSelectedAll || this.selectedRowsMap.size === 0) && !selectedId) {
            r.isSelectAll = true;
            this.deselectedFromSelectAllRecords.forEach((node: any) => {
                r.deselectedIds.push(node.accountId);
            });
        } else {
            r.isSelectAll = false;

            if(!selectedId) {
                this.selectedRowsMap.forEach((node: any) => {
                    r.selectedIds.push(node.accountId);
                });
            }
        }

        this.aas.getExternalAccountsDetails(r).subscribe((_res: any) => {
            this.ges.showSuccessMessage();
        }, ()=>{});
    }

    showToast(severity: string, summary: string, detailedMessage: string, linkText: string, navigationPath: string) {
        if (navigationPath != null && navigationPath.length > 0) {
            this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
        }
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            key: 'irb-embedded-link-toast',
            severity: severity,
            summary: summary,
            detail: detailedMessage,
            sticky: false,
            closable: true,
            linkText: linkText,
            callBack: (() => {
                this.as.fireEvent(IrbAppEvents.HIDE_TOAST);
                if (navigationPath != null && navigationPath.length > 0) {
                    this.router.navigate([navigationPath]);
                }
            })
        });
    }

    showEditMultipleAccountsDialog() {
        const r = {} as IMultipleAccountEditRequest;
        r.selectedIds = [];
        r.deselectedIds = [];
        r.filter = this.aas._filterKeys;

        if (this.isSelectedAll || this.selectedRowsMap.size === 0) {
            r.isSelectAll = true;
            this.deselectedFromSelectAllRecords.forEach((node: any) => {
                r.deselectedIds.push(node.accountId);
            });

            r.accountCount = this.currentDisplayed - r.deselectedIds.length;
        } else {
            r.isSelectAll = false;
            this.selectedRowsMap.forEach((node: any) => {
                r.selectedIds.push(node.accountId);
            });

            r.accountCount = r.selectedIds.length;
        }

        if(r.isSelectAll || r.selectedIds.length > 1) {
            this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_MULTIPLE_ACCOUNTS, {data: r});
        } else {
            this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_ACCOUNT, {
                data: {
                    accountId: r.selectedIds[0]
                }
            });
        }
    }

    showDeleteExternalAccountsDialog() {
        const request = { isSelectAll: false } as IExternalAccountRequest;
        const selectedAccounts = this.getSelectedExternalAccounts();
            if (selectedAccounts && selectedAccounts.hasExternalAccount &&
                   selectedAccounts.externalAccounts && selectedAccounts.externalAccounts.length > 0) {

                this.as.fireEvent(IrbAppEvents.SHOW_WAIT);

                request.selectedIds = selectedAccounts.externalAccounts.map(account => account.accountId);
                 this.aas.deleteExternalAccounts(request).subscribe((response) => {

                    if (response && response.affected_portfolio_list && response.affected_portfolio_list.length > 0 ) {
                        this.as.fireEvent(IrbClientsEvents.SHOW_DELETE_EXTERNAL_ACCOUNTS_DIALOG, {
                            externalAccounts: selectedAccounts.externalAccounts,
                            selectedCount: selectedAccounts.selectedCount,
                            affectedPortfolios: response.affected_portfolio_list,
                            deleteContinueFunction: this.deleteContinueCallback.bind(this)
                        });
                    }

                     this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                 });
            }

    }

    getSelectedExternalAccounts() {
        const accounts: Array<any> = [];
        let selectedCount=0;
        let hasExternalAccount=false;
        if (this.gridOptions && this.params.api && typeof this.params.api.forEachNode === 'function') {
            this.params.api.forEachNode((rowNode: any) => {

                if (rowNode.isSelected()) {
                    selectedCount++;
                    if (rowNode.data.accountsubType === 'EXTERNAL') {
                        accounts.push(rowNode.data);
                        hasExternalAccount = true;
                    }

                }
            });
        }
        return { externalAccounts: accounts, selectedCount: selectedCount, hasExternalAccount: hasExternalAccount};
    }

    deleteContinueCallback(data: any) {
        this.selectedRowsMap = new Map<string, any>();
        this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            key: 'irb-embedded-link-toast',
            severity: 'success',
            summary: 'Delete External Accounts',
            detail: data.deleted_accounts_count + ' external account(s) were deleted.',
            sticky: false,
            closable: true,
            callBack: (() => {
                this.as.fireEvent(IrbAppEvents.HIDE_TOAST)
            })
        });
    }

    private compare(a: string, b: string) {
        const A = a.toUpperCase();
        const B = b.toUpperCase();

        let comparison = 0;
        if (A > B) {
            comparison = 1;
        } else if (A < B) {
            comparison = -1;
        }
        return comparison;
    }

    // getCustodianOnPermission() {
    //     this.dbs.getGlobalSettings().pipe(takeUntil(this.destroyed$)).subscribe((data:any) => {
    //         this.globalSettings = data as IGlobalSettings;
    //         if(this.globalSettings && this.globalSettings.pmsProviderDTO && this.globalSettings.pmsProviderDTO.isEnabled)
    //         {
    //           this.hasCustodianEnabled = true;
    //         }
    //         this.params.api.setColumnVisible('custodian', this.hasCustodianEnabled);

    //     if (this.hasCustodianEnabled) {
    //         this.aas.getCustodianDropDownValues().subscribe((res: ICustodianNameList) => {
    //             this.custodianNameList = res;
    //             const custName: string[] = [];
    //             for (const record of this.custodianNameList.responseData) {
    //                 if (record.name) {
    //                     custName.push(record.name);
    //                 }
    //             }
    //             custName.push('TD AMERITRADE');
    //             custName.sort(this.compare);
    //             if (custName.indexOf('(none)') > -1) {

    //                 const noneCustName = custName.splice(custName.indexOf('(none)'), 1);
    //                 custName.unshift(...noneCustName);
    //             }
    //             this.custodianNameValuesList = custName;
    //         });
    //     }
    // });
    // }

    cellRendererSelectorCashMinimum(params: any) {

        return {
            component: "cellRendererFormatter",
            params: {
                value:this.getCashMinimum(params),
                    link: (params: any) => {
                        return (params.value != null && params.value.length > 0 && !(params.data?.isGlobal));
                    },
                    onClick: (function (data: any) {
                        this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_ACCOUNT, { data: data,source:"cshNeeds" });
                    }).bind(this)
              },
          };
    }

    cellRendererSelectorCashTarget(params: any) {
        return {
            component: "cellRendererFormatter",
            params: {
                value:this.getCashTarget(params),
                    link: (params: any) => {
                        return (params.value != null && params.value.length > 0 && !(params.data?.isGlobal));
                    },
                    onClick: (function (data: any) {
                        this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_ACCOUNT, { data: data,source:"cshNeeds" });
                    }).bind(this)
              },
          };
    }

    cellRendererSelectorCashMaximum(params: any) {

        return {
            component: "cellRendererFormatter",
            params: {
                value:this.getCashMaximum(params),
                link: (params: any) => {
                    return (params.value != null && params.value.length > 0 && !(params.data?.isGlobal));
                },
                onClick: (function (data: any) {
                    this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_ACCOUNT, { data: data,source:"cshNeeds" });
                }).bind(this)
            }
          };
    }
    private setFilterChipsDisplayNames() {
        this.filterDisplayNamesData= [];
        this.filterDisplayNamesData.push({key: 'accountNumber', mapData: {displayName: 'Account', customData:{}}});
        this.filterDisplayNamesData.push({key: 'accountName', mapData: {displayName: 'Name', customData:{}}});
        this.filterDisplayNamesData.push({key: 'accountsubType', mapData: {displayName: 'Type', customData:{}}});
        this.filterDisplayNamesData.push({key: 'accountLocationType', mapData: {displayName: 'Taxability', customData:{}}});
        this.filterDisplayNamesData.push({key: 'masterAccount', mapData: {displayName: 'Master Account', customData:{}}});
        this.filterDisplayNamesData.push({key: 'marketValue', mapData: {displayName: 'Market Value', customData:{}, format: {type:'currency', digitInfo:'1.0-0'}}});
        this.filterDisplayNamesData.push({key: 'portfolio', mapData: {displayName: 'Portfolio', customData:{}}});
        this.filterDisplayNamesData.push({key: 'modelName', mapData: {displayName: 'Model', customData:{}}});
        this.filterDisplayNamesData.push({key: 'autoCashHoldForDistAmt', mapData: {displayName: 'Dist Hold', customData:{}, format: {type:'currency', digitInfo:'1.0-0'}}});
    }
    onRemoveFilterItem(filterChip: any) {
        let filterField = filterChip[0];
        this.params.api.getColumnFilterInstance(filterField).then((f:any) => {
            f.setModel(null);
            this.params.api.onFilterChanged();
        });
    }

    addRemoveFilterToPanel() {
        let customToolPanelColumnDefs: any;
        customToolPanelColumnDefs = [
            {
                headerName: 'Additional Filters',
                children: []
            }
        ];
        return customToolPanelColumnDefs;
    }

    openSACWithContext(sanc: string) {
        // If no row data, open SAC without context
        if (!this.row) {
            window.open(`${this.redirectURL}/?sanc=${sanc}`, '_blank');
            return;
        }

        const baseURL = this.util.getSacContextGatewayBaseURL();
        const firmId = this.userDetails?.firmId;

        this.cxs.init(baseURL, firmId);

        const currentContext: IContext = {
            contextId: this.row.accountNumber,
            contextType: ContextType.Account,
            name: this.row.accountName || this.row.accountNumber
        };

        this.cxs.save(currentContext)
            .then((ubid: string) => {
                const url = ubid
                    ? `${this.redirectURL}/?sanc=${sanc}&ubid=${ubid}`
                    : `${this.redirectURL}/?sanc=${sanc}`;
                window.open(url, '_blank');
            })
            .catch(() => {
                // Fallback: open SAC without UBID on error
                window.open(`${this.redirectURL}/?sanc=${sanc}`, '_blank');
            });
    }

    presetFiltersdataFromSavedFilters() {
        let savedFilters = this.getGridFilterPreference();
        if (!savedFilters)
            return;

        if (savedFilters.masterAccount)
            this.masterAccountList = savedFilters.masterAccount.values;

        if (savedFilters.portfolio) {
            this.portfolioNameValuesList = savedFilters.portfolio.values;
            this.portfolioNameList = {items: savedFilters.portfolio.list, identifier:'', label:''};
        }

        if (savedFilters.modelName) {
            this.modelNameList = {items: savedFilters.modelName.list, identifier:'', label:''};
            this.modelNameValuesList = savedFilters.modelName.values;
        }

        if (savedFilters.accountLocationType)
            this.accountLocationTypeList = savedFilters.accountLocationType.values;

        if (savedFilters.accountsubType)
            this.accountSubTypeList = savedFilters.accountsubType.values;
    }
    addHiddenColumnFiltersOnInitialLoad() {
        setTimeout(() => {
            this.firstTimeFlag = false;
            if (this.params) {
                const col = this.params.api.getColumn('autoCashHoldForDistAmt');
                if (col) {
                    let colVisibility: any = col.visible;
                    this.params.api.setColumnsVisible(['autoCashHoldForDistAmt'], !colVisibility);
                    this.params.api.setColumnsVisible(['autoCashHoldForDistAmt'], colVisibility);
                }
            }
        });
    }
    getTemplate(params: any) {
        this.row = params.data;
        return this.accountNumberOverlay;
    }

    closeMenu() {
        this.ctas.remove();
    }
}
